module.exports = __webpack_public_path__ + "media/images/icon__calendar@2x-158eb4b49036aae29d404ed506bb5431.png";